import { useQuery } from "@tanstack/react-query"
import { getSubscription } from "../services"
import type { TSubscription } from "../types"

export const subscriptionKeys = {
  all: (workspaceId: string) => ["subscription", workspaceId] as const,
}

const DEV_MOCK = false

export function useGetSubscription(
  workspaceId: string,
  options?: { enabled?: boolean },
) {
  if (DEV_MOCK) {
    console.warn("[useGetSubscription stub]")
    return { data: null, isLoading: false, isError: false, refetch: () => Promise.resolve() }
  }

  return useQuery<TSubscription>({
    queryKey: subscriptionKeys.all(workspaceId),
    queryFn: ({ signal }) => getSubscription(workspaceId, signal),
    enabled: options?.enabled ?? !!workspaceId,
    staleTime: 1000 * 60 * 5,
    retry: 1,
  })
}
